import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OphButtonModule} from 'src/app/shared/design/oph-button/oph-button.module';
import {TaskLoadingState} from '../../shared/model/task-loading-state';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'current-sked-detail-update-button',
  standalone: true,
  imports: [OphButtonModule, MatProgressSpinnerModule],
  templateUrl: './current-sked-detail-update-button.component.html',
  styleUrl: './current-sked-detail-update-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedDetailUpdateButtonComponent {
  @Input() loading: TaskLoadingState;
  @Input() subtaskIndex: number;
  @Input() disabled: boolean;
  @Input() buttonText: string = 'Complete Subtask';

  @Output() buttonClick = new EventEmitter();
}
